export enum FileTypeEnum {
  CentreFile = 1,
  ClientFile = 2,
  ResourceDocument = 3,
  PolicyDocument = 4,
  NewsFile = 5,
  FormTemplate = 6,
}
